var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonTable',{attrs:{"data":_vm.formattedData,"columns":_vm.columns,"max-height":"37vh"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }